import React, { useEffect, useState } from "react"
import { Button, Descriptions, Divider, Drawer, Input, InputNumber, message } from "antd"
import ShowKnifeInfo from "../../Knives/ShowKnifeInfo"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { TextArea } = Input

export default function FinishCutterOrder(props) {
  const { order } = props
  const [open, setOpen] = useState(false)

  const { user } = useAuthContext()

  //finish order details
  const [finishedQ, setFinishedQ] = useState(0)
  const [core, setCore] = useState(40)
  const [boxCount, setBoxCount] = useState(0)

  //finish comment
  const [comment, setComment] = useState("")

  //disable finish button
  const [finishButtonDisabled, setFinishButtonDisabled] = useState(false)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //handle quantity
  const handleQuantity = (value) => {
    setFinishedQ(value)
  }

  //handle core
  const handleCore = (value) => {
    setCore(value)
  }

  //handle box count
  const handleBoxes = (value) => {
    setBoxCount(value)
  }

  //checks the button disable
  useEffect(() => {
    if (finishedQ === 0 || core === 0 || boxCount === 0) {
      setFinishButtonDisabled(true)
    } else {
      setFinishButtonDisabled(false)
    }
  }, [core, finishedQ, boxCount])

  //handle finish the order
  const handleOrderFinish = async () => {
    const ref = doc(db, "orders", order.id)
    try {
      await updateDoc(ref, {
        updated: serverTimestamp(),
        amountCreated: finishedQ,
        cutter: user.uid,
        cutterEmail: user.email,
        doneByCutter: serverTimestamp(),
        orderStatus: 6,
        rewinderComment: comment,
        boxesCount: boxCount,
        coreSize: core,
      })
    } catch (error) {
      message.error("error happened")
      console.log(error)
    } finally {
      setOpen(false)
      message.success("order finished")
    }
  }

  return (
    <div>
      <Button size="small" type="primary" onClick={showDrawer}>
        Fill Order
      </Button>
      <Drawer
        title={order.selectedProduct.product.productName}
        placement="left"
        onClose={onClose}
        open={open}>
        <Divider>Order Details</Divider>

        <Descriptions column={1}>
          <Descriptions.Item label="Client">{order.client.client}</Descriptions.Item>
          <Descriptions.Item label="Product">
            {order.selectedProduct.product.productName}
          </Descriptions.Item>
          <Descriptions.Item label="Quantity (pcs)">{order.labelCount}</Descriptions.Item>
          <Descriptions.Item label="Die-Cut">
            <ShowKnifeInfo
              knifeId={order.selectedProduct.knifeId}
              knifeCode={order.selectedProduct.knifeCode}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Width">{order.selectedProduct.labelWidth}</Descriptions.Item>
          <Descriptions.Item label="Height">{order.selectedProduct.labelHeight}</Descriptions.Item>
          <Descriptions.Item label="Material">{order.selectedProduct.material}</Descriptions.Item>
          <Descriptions.Item label="Manager Comment">{order.salesComment}</Descriptions.Item>
        </Descriptions>

        <Divider> Finish order details</Divider>
        <Descriptions column={1}>
          <Descriptions.Item label="Finished Quantity">
            <InputNumber
              onChange={handleQuantity}
              size="small"
              style={{ width: "100%" }}
              value={finishedQ}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Core size">
            <InputNumber
              onChange={handleCore}
              size="small"
              style={{ width: "100%" }}
              value={core}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Box Count">
            <InputNumber
              onChange={handleBoxes}
              size="small"
              style={{ width: "100%" }}
              value={boxCount}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Comment">
            <TextArea
              onChange={(event) => setComment(event.target.value)}
              size="small"
              style={{ width: "100%" }}
              value={comment}
            />
          </Descriptions.Item>
        </Descriptions>

        <Button disabled={finishButtonDisabled} onClick={handleOrderFinish} type="primary" block>
          Finish the order
        </Button>
      </Drawer>
    </div>
  )
}
